'use strict';

setTimeout(function() {
    if ($('.js-section-navigation').length) {
        preInit();
    } else {
        // no nav = exit module
    }
},500);

var preInit = function preInit() {
    var $sectionNav = $('.js-section-navigation'),
        $sectionNavLink = $sectionNav.find('a');

    // if the section nav needs to be dynamic
    if ($sectionNav.hasClass('js-section-navigation-dynamic')) {
        // search main content for headings
        // element is placed in a sidebar, which is a o-layout__item.
        // we need to search the content in the sibling
        var $layout = $sectionNav.closest('.o-layout'),
            $sections = $layout.find('span.js-section-navigation-indicator');

        $sectionNav.find('ul').empty();

        _.each($sections, function(section) {
            // if el has no id, add it!
            if (!$(section).prop('id')) {
                // create random number
                var rand = Math.floor(Math.random()*90000) + 10000,
                    customId = 'section_'+ rand;
                // add it to the section id
                $(section).prop('id', customId);
            }

            // add link to sectionNav
            var sectionText = $(section).text(),
                href = '#'+ $(section).prop('id'),
                listItem = '<li><a href="' + href + '" data-link="' + href + '">' + sectionText + '</a></li>';

            // append the link to the list
            $sectionNav.find('ul').append(listItem);

        });

        init();
    } else {
        init();
    }
}

// i've put the previous code in an init function. Entire module needs refactoring.
var init = function init() {

    $('.js-section-navigation').on('click', 'ul li a', function (e) {
        e.preventDefault();

        var $thisHref = $($(this).attr('href'));

        var body = $('html, body'),
            scrollTo = $thisHref.offset().top - 100;

        body.animate({scrollTop:  scrollTo}, 300);
    })

    // forEach method, that passes back the stuff we need
    var forEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        }
    };

    // Find navigation links and save a reference to them
    var nav = document.querySelector(".js-section-navigation"),
        links = nav.querySelectorAll("a");

    // "content" will store all the location cordinates
    var content;


    // Set up an array of locations which we store in "content"
    var setupLocations = function () {
        content = [];
        forEach(links, function (i, el) {
            var href = links[i].getAttribute("href").replace("#", "");

            if(document.getElementById(href)) {
                content.push(document.getElementById(href).offsetTop + 350);
            }
        });
    };

    // call locations set up once
    setupLocations();

    // Re-calculate locations on window resize and orientation change
    if (document.addEventListener) {
        window.addEventListener("resize", function () {
            setupLocations();
        }, false);
    }

    $('.c-section-navigation').append('<span class="c-section-navigation__indicator"/>')

    // Highlight active link on the navigation
    var selectActiveMenuItem = function (i) {
        forEach(links, function (i, el) {
            links[i].parentNode.className = links[i].parentNode.className.replace(/[\s]{0,}active/, "");
        });

        links[i].parentNode.className += links[i].parentNode.className ? " active" : "active";
        $('.c-section-navigation__indicator').css({ 'transform' : 'translateY(' + (i * 60) + 'px)'})
    };

    // Highlight active link when scrolling
    $(window).on('scroll', _.debounce(function() {
        // Determine viewport and body size
        var top = window.pageYOffset,
            body = document.body,
            html = document.documentElement,
            viewport = window.innerHeight,
            bodyheight = Math.max(
                body.scrollHeight,
                body.offsetHeight,
                html.clientHeight,
                html.scrollHeight,
                html.offsetHeight
            );

        // For each content link, when it's in viewport, highlight it
        forEach(content, function (i, loc) {
            if ((loc > top && (loc < top + 500 || (top + viewport) >= bodyheight))) {
                selectActiveMenuItem(i);
            }
        });

    }, 200));
}
